import { useCallback, useEffect, useState } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'
import { Loader } from 'core-components/library/loader'
import { downloadQbrAttachment } from 'partner360/components/QBR/api/downloadQbrAttachment'
import { TRANSLATION_KEYS } from 'partner360/components/QBR/translations'

import { fetchAllDocumentAttachments } from './api/fetchAllDocumentAttachments'
import { IQBRAttachmentForDownload } from './models'

import styles from './AttachmentsForDownload.module.scss'

interface IProps {
  documentEntryId: number
}

export const AttachmentsForDownload = ({ documentEntryId }: IProps) => {
  const [wip, setWip] = useState(true)

  const [allAttachments, setAllAttachments] = useState<IQBRAttachmentForDownload[]>([])

  const onClick = useCallback(
    (attachmentForDownload: IQBRAttachmentForDownload) => async () => {
      setWip(true)
      await downloadQbrAttachment({
        uid: attachmentForDownload.UID,
        fieldName: attachmentForDownload.FieldName,
        fileName: attachmentForDownload.FileName,
        formId: attachmentForDownload.FormId,
      })
      setWip(false)
    },
    []
  )

  useEffect(() => {
    setWip(true)
    fetchAllDocumentAttachments(documentEntryId).then((res) => {
      setAllAttachments(res)
      setWip(false)
    })
  }, [documentEntryId])

  if (wip) {
    return <Loader />
  }

  if (!allAttachments.length) {
    return (
      <div className={styles.noData}>
        <Translation text={TRANSLATION_KEYS.downloadAllAttachments.noData} />
      </div>
    )
  }

  return (
    <div tabIndex={1} className={styles.root}>
      {allAttachments.map((item) => {
        return (
          <div key={item.EntryId} className={styles.attachmentWrapper} onClick={onClick(item)}>
            <div className={styles.name}> {item.FileName}</div>
            <Button iconButton={'kbase kbase-download'} />
          </div>
        )
      })}
    </div>
  )
}
